import { createReducer } from 'redux-create-reducer'
import * as ActionTypes from '../actions/actionTypes.js'

const submissionsInit = {
	isFetching: false,
	didInvalidate: false,
	items: {
		mock1: {
			shell: true
		},
		mock2: {
			shell: true
		},
		mock3: {
			shell: true
		}
	}
}

export const submissions = createReducer(submissionsInit, {
	[ActionTypes.SUBMISSION_CREATE_SUCCESS](state, { payload }) {
		return {
			...state,
			didInvalidate: true,
			items: {
				mock1: {
					shell: true
				}
			}
		}
	},
	[ActionTypes.SUBMISSION_CANCEL_SUCCESS](state, { payload }) {
		return {
			...state,
			didInvalidate: true,
			items: {
				mock1: {
					shell: true
				}
			}
		}
	},
	[ActionTypes.SUBMISSION_LIST_REQUEST](state) {
		return { ...state, isFetching: true, didInvalidate: false }
	},
	[ActionTypes.SUBMISSION_LIST_SUCCESS](state, { payload }) {
		return {
			...state,
			isFetching: false,
			didInvalidate: false,
			items: payload.items,
			lastUpdated: payload.receivedAt
		}
	},
	[ActionTypes.SUBMISSION_LIST_FAILURE](state, { payload }) {
		return { ...state }
	}
})



// WEBPACK FOOTER //
// ./src/reducers/submissions.js